import {StartupConfigResponse} from "@/models/api/old/responses";

export class StartupConfig {
    imprintLink:string;
    privacyLink:string;
    disclaimerLink:string;
    contactPerson:string = "workplace@oge.net"; //TODO get this into startup response?!
    authUrl:string;
    clientId:string;
    clientScopes:string;

    constructor(respObj: StartupConfigResponse) {
        this.imprintLink = respObj.impressum
        this.privacyLink = respObj.datenschutz
        this.disclaimerLink = respObj.disclaimer
        this.authUrl = respObj.authUrl
        this.clientId = respObj.clientId
        this.clientScopes = respObj.clientScopes
    }
}